import { Component } from "solid-js";

interface FoodIconProps {
  class?: string;
}

export const FoodIcon: Component<FoodIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M18.6667 20V18.6667C18.6667 16.4574 16.876 14.6667 14.6667 14.6667H8C5.79067 14.6667 4 16.4574 4 18.6667V20"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 28H6.66667C5.19333 28 4 26.8067 4 25.3333V24H18.6667V25.3333C18.6667 26.8067 17.4733 28 16 28Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.66675 20H20.0001"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.2455 14.6666L13.7375 10.8426C13.6322 10.0426 14.2535 9.33331 15.0602 9.33331H26.6668C27.4788 9.33331 28.1015 10.052 27.9868 10.8546L25.7015 26.8546C25.6068 27.512 25.0442 28 24.3815 28H21.5375"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.5374 4H22.688C22.0267 4 21.4667 4.484 21.3694 5.13733L20.7454 9.33333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
